import { createAction, props } from '@ngrx/store';
import { IVariableDosageResponse } from 'src/app/pages/orders/interfaces/product.interface';

export const loadVariableDosage = createAction(
  '[Variable Dosage] Load',
  props<{
    applicationCode: string;
    country: string;
    subgroup: string;
    deliveryDate: string;
    commProduct: string;
    key: string;
  }>(),
);

export const loadVariableDosageSuccess = createAction(
  '[Variable Dosage] Load Success',
  props<{ key: string; data: IVariableDosageResponse }>(),
);

export const loadVariableDosageFailure = createAction(
  '[Variable Dosage] Load Failure',
  props<{ key: string; error: any }>(),
);

export const clearVariableDosageByKey = createAction('[Variable Dosage] Clear By Key', props<{ key: string }>());
